import React from 'react';
export var Error = function (_a) {
    var _b = _a.error, error = _b === void 0 ? null : _b, _c = _a.debug, debug = _c === void 0 ? false : _c;
    return (React.createElement("div", { className: "sui-flex sui-items-center sui-justify-center sui-h-[80vh]", "data-testid": "errorContent" },
        React.createElement("div", { className: "sui-text-center" },
            React.createElement("img", { src: "https://assets.homedepot-static.com/images/v1/oops.svg", alt: "oopsImage", width: "702", height: "205" }),
            React.createElement("div", { className: "sui-text-sm sui-py-2" },
                React.createElement("p", null, "WE'RE FIXING IT."),
                React.createElement("p", null, "We'll have this patched up as soon as possible.")),
            error && debug && (React.createElement("pre", null,
                React.createElement("code", null, error.stack))),
            React.createElement("div", null,
                React.createElement("a", { className: "bttn bttn--primary bttn--inline u__bottom--standard body__m-right-large", href: "/" },
                    React.createElement("span", { className: "bttn__content" }, "Back to homepage"))))));
};
